"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsContext = void 0;
var react_1 = require("react");
exports.ControlsContext = (0, react_1.createContext)({
    selected: "",
    name: "",
    register: {},
});
exports.ControlsContext.displayName = "ControlsContext";
